import React from "react";
import { Slider } from "@/components/ui/slider";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * Combined slider + numeric input field with label.
 * Props: label, value, onChange, min, max, step, unit, testId, sliderTheme
 */
export const NumberField = ({
  label,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  unit = "",
  testId,
  sliderTheme = "algae-slider",
  hint,
}) => {
  const clamp = (v) => Math.min(max, Math.max(min, Number(v) || 0));
  return (
    <div className="space-y-2">
      <div className="flex items-baseline justify-between gap-3">
        <Label className="text-xs font-semibold tracking-wider uppercase text-slate-400">
          {label}
        </Label>
        <div className="flex items-center gap-2">
          <Input
            data-testid={testId ? `${testId}-input` : undefined}
            type="number"
            value={value}
            min={min}
            max={max}
            step={step}
            onChange={(e) => onChange(clamp(e.target.value))}
            className="h-8 w-32 bg-slate-950/80 border-slate-800 text-right font-mono-tab text-sm text-slate-100 focus:border-emerald-500/60 focus:ring-emerald-500/20"
          />
          {unit && (
            <span className="text-xs font-medium text-slate-500 min-w-[42px]">
              {unit}
            </span>
          )}
        </div>
      </div>
      <Slider
        data-testid={testId ? `${testId}-slider` : undefined}
        value={[value]}
        min={min}
        max={max}
        step={step}
        onValueChange={(v) => onChange(clamp(v[0]))}
        className={sliderTheme}
      />
      {hint && <p className="text-[11px] text-slate-500 italic">{hint}</p>}
    </div>
  );
};
